import { MacroObjectType } from '../models/macro-object-type';

export class MailTemplate {
    Id: number;
    DisplayName: string;
    Description: string;
    Key: string;

    Subject: string;
    Body: string;

    CustomSubject: string;
    CustomBody: string;

    UseCustom: boolean;
    MacroObjectType: MacroObjectType;

    CreatedBy: number;
    CreatedDate: Date;
    UpdatedBy: number;
    UpdatedDate: Date

    constructor(source?: Partial<MailTemplate>) {
        if (source) {
            Object.assign(this, source);
        }
    }
}